import { getScrollTop } from './scroll-util';

class ParallaxFxWatcher {
	constructor(sourceEls) {
		this.curScrollPos = getScrollTop();
		this.prevScrollPos = 0;
		this.sourceEls = sourceEls;
		this.watchedEls = [];

		this.scrollFrameRef = 0;

		this.buildWatchedElementList();
		this.handleScroll();

		document.addEventListener('scroll', () => {
			if (this.scrollFrameRef) {
				window.cancelAnimationFrame(this.scrollFrameRef);
			}

			this.scrollFrameRef = window.requestAnimationFrame(this.handleScroll);
		});

		document.addEventListener('resize', () => {
			this.buildWatchedElementList();
			this.handleScroll();
		});
	}

	handleScroll = () => {
		this.prevScrollPos = this.curScrollPos;
		this.curScrollPos = getScrollTop();

		this.watchedEls.forEach((watchedEl) => {
			let percentScrolled = 0;

			if (this.curScrollPos < watchedEl.yUpperThreshold) {
				// have not reached element
				percentScrolled = 0;
			} else if (this.curScrollPos > watchedEl.yLowerThreshold) {
				// have passed element
				percentScrolled = 100;
			} else {
				const yDiff = this.curScrollPos - watchedEl.yUpperThreshold;

				percentScrolled = ((yDiff / watchedEl.thresholdHeight) * 100).toFixed(4);
			}

			watchedEl.el.style.setProperty('--parallax-scroll-percent', `${percentScrolled}%`);
		});

		this.scrollFrameRef = 0;
	};

	buildWatchedElementList() {
		this.watchedEls = this.sourceEls.map((sourceEl) => {
			const bounds = sourceEl.getBoundingClientRect();

			// bounds.top will be reported as relative to the current scroll position
			// and this will ensure the absoluteTop value is always relative to the
			// window y-axis
			const absoluteTop = getScrollTop() + bounds.top;

			const upperThresholdValue = absoluteTop > 200 ? 200 : 0;
			const lowerThresholdValue = 200;

			return {
				el: sourceEl,
				yUpperThreshold: absoluteTop - upperThresholdValue,
				yLowerThreshold: absoluteTop + bounds.height + lowerThresholdValue,
				height: bounds.height,
				thresholdHeight: bounds.height + upperThresholdValue + lowerThresholdValue
			};
		});
	}
}

export default ParallaxFxWatcher;
